import { render } from "./DuelsGameStats.vue?vue&type=template&id=d325f1f0&scoped=true"
import script from "./DuelsGameStats.vue?vue&type=script&lang=js"
export * from "./DuelsGameStats.vue?vue&type=script&lang=js"

import "./DuelsGameStats.vue?vue&type=style&index=0&id=d325f1f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d325f1f0"]])

export default __exports__